import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["WordGameHeroImage"] */ "/vercel/path0/src/features/demos/WordGameHeroImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FifaModeArtLazy"] */ "/vercel/path0/src/features/fifa-universe/FifaModeArtLazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuscaminasBanner"] */ "/vercel/path0/src/features/marketing/public/BuscaminasBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredCardArt"] */ "/vercel/path0/src/features/marketing/public/DeferredCardArt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredWordDailyBoard"] */ "/vercel/path0/src/features/marketing/public/DeferredWordDailyBoard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayNowLink"] */ "/vercel/path0/src/features/marketing/public/PlayNowLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicGameEmbed"] */ "/vercel/path0/src/features/marketing/public/PublicGameEmbed.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/marketing/public/PublicLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicPageBoard"] */ "/vercel/path0/src/features/marketing/public/PublicPageBoard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/application-utilities.css");
